{
  "llama-3.2-1b-instruct": {
    "engine": "transformers",
    "modelName": "Llama-3.2-1b-Instruct",
    "modelType": "text-generation",
    "repo": "Xenova/llama-3.2-1b-instruct",
    "pipeline": "text-generation",
    "defaultParams": {
      "temperature": 0.7,
      "maxLength": 2048
    },
    "defaultQuantization": "q4"
  },
  "whisper-tiny-en": {
    "engine": "transformers",
    "modelName": "whisper-tiny-en",
    "modelType": "automatic-speech-recognition",
    "repo": "onnx-community/whisper-tiny.en",
    "pipeline": "automatic-speech-recognition",
    "defaultQuantization": "q4",
    "quantizations": ["q4", "fp16", "int4"]
  },
  "whisper-base-all": {
    "engine": "transformers",
    "modelName": "whisper-base-all",
    "modelType": "automatic-speech-recognition",
    "repo": "onnx-community/whisper-base_timestamped",
    "pipeline": "automatic-speech-recognition",
    "defaultQuantization": "q4",
    "quantizations": ["q4", "fp16", "int4"]
  },
  "whisper-small-all": {
    "engine": "transformers",
    "modelName": "whisper-small-all",
    "modelType": "automatic-speech-recognition",
    "repo": "onnx-community/whisper-small_timestamped",
    "pipeline": "automatic-speech-recognition",
    "defaultQuantization": "q4",
    "quantizations": ["q4", "fp16", "int4"]
  },
  "kokoro-tts": {
    "engine": "transformers",
    "modelName": "kokoro-tts",
    "modelType": "text-to-speech",
    "repo": "onnx-community/Kokoro-82M-v1.0-ONNX",
    "pipeline": "text-to-speech",
    "defaultQuantization": "fp32",
    "quantizations": ["q4", "q8", "fp32", "fp16", "q4f16"],
    "defaultParams": {
      "language": "en"
    }
  },
  "janus-1.3b": {
    "engine": "transformers",
    "modelName": "Janus-1.3B-ONNX",
    "modelType": "multimodal",
    "repo": "onnx-community/Janus-1.3B-ONNX",
    "pipeline": "multimodal",
    "defaultQuantization": "q4f16",
    "quantizations": ["q4", "q8", "fp32", "fp16", "q4f16"],
    "defaultParams": {
    }
  }
} 